import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoDialogComponent } from './dialogs/video-dialog/video-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ImageDialogComponent } from './dialogs/image-dialog/image-dialog.component';

@NgModule({
    declarations: [VideoDialogComponent, ImageDialogComponent],
    imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule]
})
export class ExternalCommunicationModule {}
